(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/views/partials/get-new-qr.js') >= 0) return;  svs.modules.push('/modules/player-login/views/partials/get-new-qr.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_login=_svs.player_login||{};
_svs.player_login.templates=_svs.player_login.templates||{};
svs.player_login.templates.get_new_qr = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"align-center pointer js-retry padding-top-3\">\n  <div>"
    + container.escapeExpression((lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"icon",{"name":"ui","hash":{"color":"fc-sport","icon":"refresh","size":"300"},"data":data,"loc":{"start":{"line":2,"column":7},"end":{"line":2,"column":63}}}))
    + "</div>\n  <div class=\"f-bold margin-xs-top-1\">HÄMTA NY QR-KOD</div>\n</div>\n";
},"useData":true});
Handlebars.partials['svs-player_login-get_new_qr'] = svs.player_login.templates.get_new_qr;
})(svs, Handlebars);

 })(window);